import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {CustomerRevenueReport} from "../../models/reporting/CustomerRevenueReport";
import {
    FETCH_CUSTOMER_REVENUE_REPORT,
    FETCH_CUSTOMER_REVENUE_REPORT_ERROR,
    FETCH_CUSTOMER_REVENUE_REPORT_SUCCESS,
    CustomerRevenueReportActionTypes
} from "../../actions/reporting/CustomerRevenueReportActions";

export interface CustomerRevenueReportState {
    totalEntries: number
    entries: Nullable<CustomerRevenueReport[]>
    request: RequestState
}

const initialState: CustomerRevenueReportState = {
    totalEntries: 0,
    entries: null,
    request: getInitialRequestState()
}

export function CustomerRevenueReportReducer(
    state: CustomerRevenueReportState = initialState,
    action: CustomerRevenueReportActionTypes
) {

    switch (action.type) {
        case FETCH_CUSTOMER_REVENUE_REPORT:
            return {
                ...state,
                totalEntries: 0,
                entries: null,
                request: startFetchingRequestState()
            };
        case FETCH_CUSTOMER_REVENUE_REPORT_SUCCESS:
            return {
                ...action.reports,
                request: successFetchingRequestState()
            };
        case FETCH_CUSTOMER_REVENUE_REPORT_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState(action.error)
            };
        default:
            return state;
    }

}
